export default {
	copy(text) {
		let input = document.createElement('textarea');
	    input.value = text;
	    document.body.appendChild(input);
	    input.select();
	    document.execCommand('copy');
	    document.body.removeChild(input);
    	this.$setMessages(['Copied to clipboard!']);
	}
};